import type { Router } from 'vue-router';
import createMicroGuard from '@/router/guard/microGuard';
import createProgressGuard from '@/router/guard/progressGuard';

// 配置守卫
export default function setupRouterGuard(router: Router) {
  createMicroGuard(router);
  createProgressGuard(router);
}
